module.exports = __webpack_public_path__ + "static/media/7-antipolicebrutalityflyer.6053c267.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/7-antipolicebrutalityflyer.pdf
// module id = 161
// module chunks = 0